import React from "react";
import Header from "./customer/Header";
import AppFooter from "./customer/AppFooter";
import HomeHeader from "./customer/HomeHeader";

const ContactUs = () => {
  const access = localStorage.getItem("accessToken");

  console.log("Access Token:", access);

  return (
    <div>
      {access ? <Header /> : <HomeHeader />}
      <div className="h-[300px] flex justify-center  text-[#9061DB]">
        <h1 className="text-4xl font-semibold py-10">Contact Us</h1>
      </div>
      <AppFooter></AppFooter>
    </div>
  );
};

export default ContactUs;
